import { ParallelOptions } from './piterate';
import { pqueue } from './pqueue';

/**
 * Allows async mapping of an iterable, and returns results as an array.
 * Result order IS guaranteed to match input order.
 * @param iterable
 * @param fnMapper
 * @param options
 */
export async function pmap<T, U>(
	iterable: Iterable<T>,
	fnMapper: (item: T, index: number) => Promise<U> | U,
	options?: ParallelOptions
): Promise<U[]> {
	const results: U[] = [];

	await pqueue(
		iterable,
		fnMapper,
		(result, index) => {
			results.push(result);
		},
		options
	);

	return results;
}
